import * as React from 'react'

interface LoadingProps {
	size?: number
}

const Loading: React.FunctionComponent<LoadingProps> = () => <div>Loading</div>

export default Loading
